// Recharts/ResponsiveContainer can trigger a browser-level ResizeObserver loop warning
// during rapid layout changes. In Create React App dev mode, the React error overlay
// treats that warning like a runtime crash. The warning is non-fatal, so filter it
// before the overlay receives it.
const RESIZE_OBSERVER_LOOP_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

function isResizeObserverLoopMessage(message) {
  return RESIZE_OBSERVER_LOOP_MESSAGES.some((knownMessage) => String(message || '').includes(knownMessage));
}

if (typeof window !== 'undefined' && !window.__operationsKpiResizeObserverFixInstalled) {
  window.__operationsKpiResizeObserverFixInstalled = true;

  window.addEventListener(
    'error',
    (event) => {
      if (isResizeObserverLoopMessage(event?.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      const reason = event?.reason;
      const message = reason?.message || reason;
      if (isResizeObserverLoopMessage(message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
}
